import ReactPaginate from "react-paginate";
import React, {useMemo} from "react";
import styled from "styled-components";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import {TextNotFount} from "../../../components/Theme/components/cardArticulo.elements";
import {Cardsection} from "../../../ui";
import {CatalogItemCard} from "../../../common/ui/CatalogItemCard";
import {ProductFlatPurchaseCardUI} from "../../../product/ui/ProductFlatPurchaseCardUI";
import {PriceWithFallback} from "../../../common/ui/PriceWithFallback";
import {useCartPromotions} from '../../../cart/hooks/useCartPromotions';

const DivPagination = styled.div`
    padding: 3rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const PaginatedCatalog = ({catalog = {}, viewMode, onPageChange}) => {

    const { promotions } = useCartPromotions();

    // Build a Set of product codes that have at least one PRODUCT-scoped combinable promotion
    const comboPromoCodes = useMemo(() => {
        const codes = new Set();
        (promotions ?? []).forEach(p => {
            if (p.scope === 'PRODUCT' && p.combinable && p.scopeValues) {
                p.scopeValues.split(',').forEach(code => codes.add(code.trim()));
            }
        });
        return codes;
    }, [promotions]);

    const renderGrid = () => (
        <Cardsection>
            {catalog.content.map((product, index) => (
                <div key={index}>
                    <CatalogItemCard data={{catalogItem: product}} hasComboPromo={comboPromoCodes.has(product.code)}>
                        <CatalogItemCard.Price>
                            <PriceWithFallback data={{sellingPrice: product.price?.bestPrice, basePrice: product.price?.value}}/>
                        </CatalogItemCard.Price>
                    </CatalogItemCard>
                </div>
            ))}
        </Cardsection>
    );

    const renderList = () => (
        <div className="cardList">
            {catalog.content.map((product, index) => (
                <div key={index} className="my-1">
                    <ProductFlatPurchaseCardUI details={product} hasComboPromo={comboPromoCodes.has(product.code)}/>
                </div>
            ))}
        </div>
    );

    return (
        <>
            {
                catalog.content.length === 0 ? (
                    <div className="text-center d-grid justify-content-center align-items-center">
                        <div>
                            <Inventory2OutlinedIcon/>
                        </div>
                        <TextNotFount>No se han encontrado resultados. <br/> </TextNotFount>
                        <a href={'/articulos'} className="text-primary"> Ver todos los productos</a>
                    </div>
                ) : (
                    viewMode === 'grid' ? renderGrid() : renderList()
                )
            }

            <DivPagination>
                <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={catalog.totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => onPageChange(selectedItem.selected)}
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={catalog.pageable.pageNumber}
                />
            </DivPagination>
        </>
    );
}